import Utils from './Utils'

export default {
    getInferenceOverridableField(well, fieldName) {
        const overrideValue = this.resolve(fieldName, well.inferenceOverridingData)

        if (Utils.isUndefined(overrideValue)) {
            return this.resolve(fieldName, well.inferenceData)
        } else {
            return overrideValue
        }
    },
    resolve(path, obj) {
        return path.split('.').reduce(function (prev, curr) {
            return prev ? prev[curr] : undefined
        }, obj || self)
    }
}
